import React, { useEffect, useState } from 'react';
import API from '../../../Utils/api';
import { useUser } from '../../../Context/useUser';
import { useParams } from 'react-router';
import { useVisitingUser } from '../../../Hooks/useVisitingUser';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SWIMMING_STYLES_DISPLAY = {
    freestyle: 'Free Style',
    backStroke: 'Back Stroke',
    breastStroke: 'Breast Stroke',
    butterfly: 'Butterfly',
    individualMedley: 'Individual Medley'
};

const COLORS = ['#1E40AF', '#60A5FA', '#1E293B', '#A5B4FC', '#E5E7EB'];

export default function SwimmingStylesChart() {
    const { user } = useUser();
    const { athleteId } = useParams();
    const visitedUser = useVisitingUser(athleteId);
    const currentUser = athleteId ? visitedUser : user;
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser) return;
        setLoading(true);
        API.getSwimmingStylesStats(currentUser._id)
            .then(({ data }) => setStats(data))
            .finally(() => setLoading(false));
    }, [currentUser]);

    const chartData = {
        labels: stats.map(s => SWIMMING_STYLES_DISPLAY[s.style]),
        datasets: [
            {
                label: 'Distance (m)',
                data: stats.map(s => s.distance),
                backgroundColor: COLORS,
                borderRadius: 12,
                barPercentage: 0.7,
                categoryPercentage: 0.7,
                borderSkipped: false
            }
        ]
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        plugins: {
            legend: { display: false },
            datalabels: {
                color: '#fff',
                anchor: 'center',
                align: 'center',
                font: { weight: 'bold', size: 16 },
                formatter: (value, context) => `${stats[context.dataIndex]?.percentage ?? 0} %`,
                display: context => context.dataset.data[context.dataIndex] > 0
            },
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function (context) {
                        const stat = stats[context.dataIndex];
                        return `${SWIMMING_STYLES_DISPLAY[stat.style]}: ${stat.distance}m (${
                            stat.percentage
                        }%)`;
                    }
                }
            },
            title: { display: false }
        },
        scales: {
            x: {
                beginAtZero: true,
                grid: { color: '#ccc' },
                title: { display: true, text: 'Distance (m)' }
            },
            y: {
                grid: { color: '#ccc' }
            }
        }
    };

    return (
        <>
            <h4 style={{ marginBottom: 10 }}>Swimming Styles</h4>
            {loading ? (
                <div>Loading...</div>
            ) : stats.length === 0 ? (
                <div>No data found.</div>
            ) : (
                <div style={{ position: 'relative' }}>
                    <Bar data={chartData} options={options} />
                </div>
            )}
        </>
    );
}
